<template>
    <div class="toolboxbg">
        <div class="container">
            <div v-if="flag==0" class="imgtemplate">
                <img :src="`https://p3.udn.com.tw/wish/images/article_pic/${getsite}_${gettext[0]}_${selectSrc_2('mob', 'pc')}.${gettext[1]}`" />
            </div>
            <div v-if="flag==4" class="imgtemplate imgtemplate_chart">
                <img :src="`https://p3.udn.com.tw/wish/images/article_pic/${getsite}_${gettext[0]}_${selectSrc_3('mob', 'pad', 'pc')}.${gettext[1]}`" />
            </div>
            <div v-if="flag==0 || flag==4" class="imgdescription">
                {{gettext[2]}}
            </div>
            <div v-if="(flag==0 || flag==4) && gettext[3]!=undefined" class="imgdescription">
                {{gettext[3]}}
            </div>
            <div v-if="flag==1" class="imgtemplate">
                <img :src="`https://p3.udn.com.tw/wish/images/progress/${gettext[0]}_${selectSrc_3('mob', 'pad', 'pc')}.${gettext[1]}`" />
            </div>
            <div v-if="flag==5" class="imgtemplate_progress">
                <img :src="`https://p3.udn.com.tw/wish/images/progress/${gettext[0]}_${selectSrc_3('mob', 'pad', 'pc')}.${gettext[1]}`" />
            </div>
            <div v-if="flag==2" :class="{whitetext:true, texttitle:titleflag}">
                {{gettext}}
            </div>
            <div v-if="flag==3" :class="{blacktext:true, texttitle:titleflag, progresstitle: progresstitleflag, progresssubtitle:progresssubtitleflag}">
                {{gettext}}
            </div>
            <div v-if="flag==6" class="imgdescription">
                {{gettext}}
            </div>
        </div>
    </div>
</template>

<script>
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    export default {
        mixins: [selectSrcMethod_3],
        data(){
            return{
                flag: -1,
                titleflag: false,
                progressflag: false,
                progresstitleflag: false,
                progresssubtitleflag: false,
                gettext: null,
            }
        },
        props: {
            eachtext: { type: null },
            hint: { type: String }
        },
        computed:{
            getsite(){
                return this.$store.state.currentwisher;
            }
        },
        mounted(){
            this.gettext=this.eachtext;
            if(typeof(this.eachtext)!=="string"){
                if(this.hint=='white') this.flag=0;
                if(this.hint=='white+') this.flag=4;
                if(this.hint=='blackg'){
                    this.flag=1;
                    this.progressflag=true;
                }
                if(this.hint=='blackg+'){
                    this.flag=5;
                    this.progressflag=true;
                }
            }
            else{
                if(this.eachtext.substr(-1)=='+'){
                    this.gettext=this.gettext.substring(0, this.eachtext.length - 1);
                    this.titleflag=true;
                }
                if(this.eachtext.substr(-1)=='*'){
                    this.gettext=this.gettext.substring(0, this.eachtext.length - 1);
                    this.progresstitleflag=true;
                }
                if(this.eachtext.substr(-1)=='-'){
                    this.gettext=this.gettext.substring(0, this.eachtext.length - 1);
                    this.progresssubtitleflag=true;
                }
                if(this.hint=='white' || this.hint=='white+') this.flag=2;
                if(this.hint=='black') this.flag=3;
                if(this.hint=='blackg' || this.hint=='blackg+'){
                    this.flag=3;
                    this.progressflag=true;
                }
                if(this.eachtext.substr(-1)=='^'){
                    this.gettext=this.gettext.substring(0, this.eachtext.length - 1);
                    this.flag=6;
                }
            }
        },
        components: {

        },
        methods:{
        },
    }
</script>

<style lang="scss" scoped>
    .toolboxbg{
        position: relative;
        width: 100%;
        text-align: justify;
        display: flex;
        justify-content: center;
        align-items: center;
        .container{
            position: relative;
            width: 92.27%;
            max-width: 768px;
            @media (min-width: 768px) AND (max-width: 960px) {
                max-width: 576px;
            }
            @media (min-width: 960px) {
                max-width: 720px;
            }
            .imgtemplate{
                width: 100%;
                @media (min-width: 768px) {
                    padding-top: 40px;
                }
                img{
                    width: 100%;
                }
            }
            .imgtemplate_chart{
                padding-top: 0px;
            }
            .imgtemplate_progress{
                width: 100%;
                img{
                    width: 100%;
                }
            }
            .imgdescription{
                margin-top: 5px;
                font-size: 16px;
                line-height: 21px;
                color:#999999;
                font-family: 'Noto Sans TC';
                font-weight: 300;
            }
            .blacktext{
                font-size: 20px;
                line-height: 35px;
                color: #E1E1E1;
                font-family: 'Noto Serif TC';
                font-weight: 300;
                opacity: 0.8;
            }
            .whitetext{
                font-size: 20px;
                line-height: 35px;
                color: black;
                font-family: 'Noto Serif TC';
                font-weight: 300;
            }
            .texttitle{
                font-size: 36px;
                line-height: 48px;
                font-weight: bold;
                color: #1D1C1B;
                padding-top: 20px;
                font-family: 'Noto Serif TC';
                @media (min-width: 768px) {
                    padding-top: 40px;
                }
            }
            .progresstitle{
                font-size: 30px;
                line-height: 40px;
                font-weight: bold;
                opacity: 1;
            }
            .progresssubtitle{
                font-size: 24px;
                line-height: 34px;
                font-weight: bold;
                opacity: 0.8;
            }
        }
    }
    .toolboxtitle{
        padding: 30px 0 0 0;
    }
    .progresstype{
        padding: 10px 0 10px 0;
    }
</style>